<div class="custom-modal">
  <div class="header-title">
    <p class="title">Agregar Observación</p>
  </div>
  <mat-divider></mat-divider>

  <form
    [formGroup]="obsForm"
    (ngSubmit)="handleConfirm()"
    class="container-content"
  >
    <div class="form-row">
      <label class="input-label"
        >Fecha de Observación<span class="req">*</span></label
      >
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          [matDatepicker]="pickerCreacion"
          formControlName="incidentDate"
          placeholder="DD/MM/AAAA"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerCreacion"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerCreacion disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-row">
      <label class="input-label">Destino<span class="req">*</span></label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-select
          formControlName="destination"
          required
          placeholder="Selecciona un destino"
        >
          <mat-option *ngFor="let dest of destinosBase" [value]="dest">
            {{ dest }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="obsForm.get('destination')?.hasError('required')"
          >El destino es obligatorio</mat-error
        >
      </mat-form-field>
    </div>

    <div
      class="form-row sub-form-row"
      *ngIf="obsForm.get('destination')?.value === 'Otros'"
    >
      <label class="input-label">Otro Destino<span class="req">*</span></label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          type="text"
          matInput
          formControlName="otherDestination"
          required
          placeholder="Ingresa una ciudad..."
          [matAutocomplete]="autoCity"
        />
        <mat-autocomplete #autoCity="matAutocomplete">
          <mat-option
            *ngFor="let city of filteredCities | async"
            [value]="city"
          >
            {{ city }}
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="obsForm.get('otherDestination')?.hasError('required')"
          >Especifique el otro destino</mat-error
        >
        <mat-error
          *ngIf="
            obsForm.get('otherDestination')?.hasError('invalidCity') &&
            !obsForm.get('otherDestination')?.hasError('required')
          "
          >Debe seleccionar una ciudad válida de la lista</mat-error
        >
      </mat-form-field>
    </div>

    <div class="form-row-radio">
      <p class="subtitle">Motivo de Observación<span class="req">*</span></p>
      <mat-radio-group formControlName="incidentReason" class="radio-group">
        <mat-radio-button
          *ngFor="let reason of incidentReasons"
          [value]="reason"
          class="custom-radio-button"
        >
          {{ reason }}
        </mat-radio-button>
      </mat-radio-group>
      <mat-error
        class="radio-error"
        *ngIf="
          obsForm.get('incidentReason')?.touched &&
          obsForm.get('incidentReason')?.hasError('required')
        "
      >
        Seleccione un motivo
      </mat-error>
    </div>

    <div
      class="form-row sub-form-row"
      *ngIf="obsForm.get('incidentReason')?.value === 'Otro'"
    >
      <label class="input-label">Otro Motivo<span class="req">*</span></label>
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          formControlName="otherReason"
          placeholder="Ingresa un motivo..."
        />
        <mat-error *ngIf="obsForm.get('otherReason')?.hasError('required')"
          >Especifique el otro motivo</mat-error
        >
      </mat-form-field>
    </div>

    <div class="form-row">
      <label class="input-label"
        >Descripción de Observación<span class="req">*</span></label
      >
      <mat-form-field appearance="outline" class="full-width textarea-field">
        <textarea
          matInput
          formControlName="description"
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="8"
          required
          placeholder="Ingresa una descripción..."
        ></textarea>
        <mat-error *ngIf="obsForm.get('description')?.hasError('required')"
          >La descripción es obligatoria</mat-error
        >
      </mat-form-field>
    </div>

    <div class="form-row">
      <label class="input-label"
        >Fecha Límite de Resolución Sugerida<span class="req">*</span></label
      >
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          [matDatepicker]="pickerLimite"
          formControlName="deadline"
          required
          placeholder="DD/MM/AAAA"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerLimite"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerLimite></mat-datepicker>
        <mat-error *ngIf="obsForm.get('deadline')?.hasError('required')"
          >La fecha límite es obligatoria</mat-error
        >
      </mat-form-field>
    </div>

    <mat-divider></mat-divider>

    <div class="modal-footer">
      <button
        mat-stroked-button
        type="button"
        mat-dialog-close
        class="button-cancel btn-action"
      >
        Cancelar
      </button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        class="button-add btn-action"
        [disabled]="obsForm.invalid || isSubmitting"
      >
        <div
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          "
        >
          <mat-spinner *ngIf="isSubmitting" diameter="20"></mat-spinner>
          <span>Agregar</span>
        </div>
      </button>
    </div>
  </form>
</div>
